var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import "./cash-flow.scss";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import useCashFlow from "@frameworks/NCD/Hook/DetailsSidebar/useCashFlow";
import { useSelector } from "react-redux";
import { getTimelineDetails } from "@frameworks/NCD/Utils/getTimelineDetails";
import { ETimelineState } from "@frameworks/NCD/Enum/OTC";
import GenericTimeline from "@frameworks/NCD/Components/GenericTimeline/GenericTimeline";
var CashFlow = function () {
    var _a, _b, _c;
    var cashFlow = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).cashFlow;
    var timelineDetails = (_a = cashFlow === null || cashFlow === void 0 ? void 0 : cashFlow.data) === null || _a === void 0 ? void 0 : _a.map(function (item, index) { return ({
        status: "\u20B9 ".concat(item.str_cashflow_price),
        statusType: ETimelineState.COMPLETED,
        dpStatusTime: item.str_cashflow_date,
    }); });
    var fetchCashFlow = useCashFlow().fetchCashFlow;
    var _d = __read(useState([]), 2), expandedKeys = _d[0], setExpandedKeys = _d[1];
    var isExpanded = expandedKeys.includes("1");
    return (React.createElement(Accordion, { alwaysOpen: true, onSelect: function (eventKey) {
            setExpandedKeys(eventKey);
        }, bsPrefix: "cashflow-accordion" },
        React.createElement(Accordion.Item, { eventKey: "1", key: "1", bsPrefix: "cashflow-accordion-item" },
            React.createElement(Accordion.Header, null,
                React.createElement("div", { className: "accordion-header d-flex justify-content-between w-100" },
                    React.createElement("div", { className: "accordion-header align-items-center" },
                        React.createElement("span", { className: "DMSanN_14_300 txt-purple-navy text-font" }, "Cashflow")),
                    React.createElement("div", { className: "arrow-wrap" },
                        React.createElement("i", { className: isExpanded
                                ? "chevron edel-icon-arrow-up txt-han-blue"
                                : "chevron edel-icon-arrow-down txt-han-blue" })))),
            React.createElement(Accordion.Body, null,
                React.createElement("div", { className: "ob-timeline-container" },
                    React.createElement("div", { className: "ob-timeline-content" }, ((_b = cashFlow === null || cashFlow === void 0 ? void 0 : cashFlow.data) === null || _b === void 0 ? void 0 : _b.length) === 0 ? (React.createElement(Errormsg, { icon: " ", msg: " ", parentClassName: "bg-transparent", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter " },
                            React.createElement("p", { className: "DMSanN_14_400" }, "No CashFlow data found")) })) : ((_c = cashFlow === null || cashFlow === void 0 ? void 0 : cashFlow.data) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (React.createElement(GenericTimeline, { timelineDetails: getTimelineDetails(timelineDetails), parentClassName: "p-0 otc-timeline-wrapper" })) : (React.createElement(Errormsg, { icon: " ", msg: "  ", parentClassName: "bg-transparent", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                            React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing page, or try again later"),
                            React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () { return fetchCashFlow(); } }, "Try Again")) }))))))));
};
export default CashFlow;
